module.exports = __webpack_public_path__ + "static/media/graph_door_01.d937685f.jpg";